import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpHeaders, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next
      .handle(request)
      .pipe(
        tap((ev:HttpEvent<any>) => {
          if (ev instanceof HttpResponse) {
            if (
              ev.body
              && ev.body.status
              && ev.body.status === 401
            ) {
              this.router.navigateByUrl("login")
            }
          }
        })
      )
  }

}
